document.addEventListener('cart:update', function (event) {
  const detail = event.detail;
  if (!detail || detail.data?.didError) return;
  if (detail.data?.source !== 'product-form-component') return;

  const productId = detail.data?.productId;
  const quantity = detail.data?.itemCount || 1;

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const item = cart.items.find(
        (i) => String(i.product_id) === String(productId)
      );
      if (!item) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: cart.currency,
          value: (item.final_price / 100) * quantity,
          items: [{
            item_id: String(item.variant_id),
            item_name: item.product_title,
            item_category: item.product_type,
            item_variant: item.variant_title,
            price: item.final_price / 100,
            quantity: quantity
          }]
        }
      });
    });
});